import { resolveOrganizationContext } from "../Admin/adminApi";

// Query the existing authoritative zone/hub endpoints, never compare city names.
export async function supplierAddressCompatibility(address, supplierId, token) {
  if (!address?.source_type) return { compatible: false };
  if (address.source_type === "organization") {
    if (!Number(address.source_id)) return { compatible: false };
    const context = await resolveOrganizationContext({ source_type: "organization", source_id: Number(address.source_id) }, token);
    return { compatible: Number(context?.supplier?.id) === Number(supplierId), context };
  }
  if (address.source_type !== "user" || !address.citta) return { compatible: false };
  const response = await fetch(`${process.env.REACT_APP_API_BASE_URL}/api/fornitori/citta/${encodeURIComponent(address.citta)}`, {
    headers: { Authorization: `Bearer ${token}` },
  });
  if (!response.ok) throw new Error("Impossibile verificare la zona servita. Riprova.");
  const suppliers = await response.json();
  return { compatible: Array.isArray(suppliers) && suppliers.some(s => Number(s.id ?? s.id_fornitore) === Number(supplierId)) };
}
